import type { IWidget } from "../widget-types/types";
import type { IDataFetcher, IDataFetcherFactory } from "./IDataFetcher";
import widgetResource from "app/common/resources/widgetResource";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { sum } from "lodash";

class SearchOverviewTotalVisitsDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const params = { ...widget.apiParams };
        let resource;
        if (params.webSource === devicesTypes.TOTAL) {
            resource = widgetResource.resourceByController(
                "MarketingMixTotal",
                "TrafficSourcesOverview",
                fetchWithFullResponseConfig,
            ).PieChart;
        } else {
            resource = widgetResource.resourceByController(
                "TrafficSourcesSearch",
                "SearchVisitsOverview",
                fetchWithFullResponseConfig,
            ).SingleMetric;
        }

        return {
            fetch: () =>
                resource(widget.apiParams)
                    .then(...fetchWithFullResponseInterceptorHandlers)
                    .then((response) => {
                        if (params.webSource === devicesTypes.TOTAL) {
                            const totalData = response.Data[devicesTypes.TOTAL][params.keys];
                            const searchTotal = totalData["Organic Search"] + totalData["Paid Search"];
                            const sumOfAllChannels = sum(Object.values(totalData));
                            const volumeTotal = searchTotal / sumOfAllChannels;

                            const parsedData = {
                                [params.keys]: {
                                    SearchTotal: searchTotal,
                                    VolumeTotal: volumeTotal,
                                },
                            };

                            return { Data: parsedData };
                        }
                        return response;
                    }),
            destroy: () => undefined,
        };
    }
}

export default new SearchOverviewTotalVisitsDataFetcherFactory();
